export default __webpack_public_path__ + "static/media/postregBg.6ca8ab19.png";